
<template>
  <div id="app">
    <b-modal
      id="modal-1"
      v-model="showModal"
      title="Update Password"
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      ok-variant
      cancel-variant
      hide-footer
      header-class="PopUpHeader"
      :body-bg-variant="PopUpVar.bodyBgVariant"
      :body-text-variant="PopUpVar.bodyTextVariant"
      :footer-bg-variant="PopUpVar.footerBgVariant"
      :footer-text-variant="PopUpVar.footerTextVariant"
    >
      <UpdatePassword
        :UpdatePasswordUser="updateUser"
        :showExit="showExit"
        :ReturnURL="returnUrl"
      ></UpdatePassword>
      <template slot="modal-header">
        <div style="margin: 0 auto">
          <small class="PopUpTitle w-100 text-center">Update Password</small>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import Vuelidate from "vuelidate";
import { helpers } from "vuelidate/lib/validators";
import Vue from "vue";
import { PopUpVariant } from "@/Common/Default/PopUpVariant";
import Modal from "@/Common/ModelPop.vue";
import LayoutDefault from '@/Common/Default/DefaultLayout.vue';
import UpdatePassword from "@/components/DPEBB/Administrator/PasswordModel.vue";
const PasswordCheck = helpers.regex(
  "alphaNum",
  /^((?=.*?[A-Z])(?=.*?[a-z])(?=.*?\d)|(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[^a-zA-Z0-9])|(?=.*?[A-Z])(?=.*?\d)(?=.*?[^a-zA-Z0-9])|(?=.*?[a-z])(?=.*?\d)(?=.*?[^a-zA-Z0-9])).{8,}$/
);
export default {
  name: "app",
  components: {
    UpdatePassword: UpdatePassword,
    Modal: Modal,
  },
  data() {
    return {
      showExit: false,
      isModalVisible: true,
      showModal: true,
      PopUpVar: PopUpVariant,
      returnUrl: "",
    };
  },
  methods: {
    // showModal() {
    //   this.isModalVisible = !this.isModalVisible;
    // },
    closeModal() {
      this.isModalVisible = false;
    },
  },
  created: function () {
     this.$emit("update:layout", LayoutDefault);
    this.returnUrl = this.$store.getters.GetReturnUrl;
    this.updateUser = this.$store.getters.GetCurrentUser;
   
  },
  beforeCreate: function () {
    this.$store.dispatch("AddServiceID", this.$store.getters.GetDPEBBServiceID);
    this.$store.dispatch("GetMenuItems", this.$store.getters.GetDPEBBServiceID);
  },
};
</script>
